import React from 'react';

import { Segment, Header, Icon, TextArea, Form, Button } from 'semantic-ui-react';
import { useAppSelector } from '../store/hooks';
import { RootState, saveToLocalStorage } from '../store/SrciStore';

export default function RequestPayload() {

  const srciInput = useAppSelector((state: RootState) => state)
  let srciInputJson = JSON.stringify(srciInput, undefined, 4)

  const exportPayloadToFile = () => {
    const blob = new Blob([JSON.stringify(srciInput)], {type: 'plain/json'})
    const fileUrl = URL.createObjectURL(blob)
    const timestamp = Date.now()

    const element = document.createElement('a')
    element.setAttribute('href', fileUrl)
    element.setAttribute('download', `demoshop-payload-${timestamp}.json`)

    document.body.appendChild(element)
    element.click()
  }

  const loadFromJsonFile = () => {
    console.groupCollapsed("Loaded custom JSON configuration")
    console.log(JSON.parse(srciInputJson))
    console.warn('Reload browser window to use changed config')
    console.groupEnd()

    window.location.reload()
  }

  const handleOnChange = (e: any) => {
    saveToLocalStorage(JSON.parse(e.target.value))
  }

  return (
    <div>
      <Header as="h5" attached="top">
        <Icon name="file code" />
        <Header.Content>Request Payload</Header.Content>
      </Header>
      <Segment size="mini" attached>
        <Form>
          <Button onClick={exportPayloadToFile}>Export to file</Button>
          <Button onClick={loadFromJsonFile}>Load from JSON</Button>
          <TextArea style={{fontFamily: "Courier"}} rows={5} onChange={handleOnChange} defaultValue={srciInputJson} />
        </Form>
      </Segment>
    </div>
  );
}